export default "__VITE_ASSET__BwDJPlMb__"